/**
 * @generated SignedSource<<047445fdb7114911eab966fdb896f616>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type UserSort = "CREATED_AT" | "DELETED_AT" | "DOB" | "EMAIL" | "EXTERNAL_ID" | "FIRST_NAME" | "GENDER" | "ID" | "I_P" | "LANGUAGES" | "LAST_NAME" | "PHONE" | "PHOTO_URLS" | "POINTS" | "RANDOM" | "SETUP_COMPLETE" | "TIME_ZONE" | "UPDATED_AT" | "WORKOS_DIR_USER_REF" | "%future added value";
export type UserOrdering = {
  direction: SortDirection;
  sort: UserSort;
};
export type accountUsersQuery$variables = {
  after?: string | null;
  first: number;
  ordering?: ReadonlyArray<UserOrdering> | null;
};
export type accountUsersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"userAccountUsersPaginationFragment">;
};
export type accountUsersQuery = {
  response: accountUsersQuery$data;
  variables: accountUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ordering"
},
v3 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "ordering",
    "variableName": "ordering"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountUsersQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "userAccountUsersPaginationFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "accountUsersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "accountUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "photoUrls",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserRole",
                    "kind": "LinkedField",
                    "name": "userRole",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "points",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "setupComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "ordering"
        ],
        "handle": "connection",
        "key": "UserAccountUsersPaginationFragment_accountUsers",
        "kind": "LinkedHandle",
        "name": "accountUsers"
      }
    ]
  },
  "params": {
    "cacheID": "cd8dc838e7183876405d36587eac3299",
    "id": null,
    "metadata": {},
    "name": "accountUsersQuery",
    "operationKind": "query",
    "text": "query accountUsersQuery(\n  $first: Int!\n  $after: String\n  $ordering: [UserOrdering!]\n) {\n  ...userAccountUsersPaginationFragment\n}\n\nfragment userAccountUsersPaginationFragment on Query {\n  accountUsers(first: $first, after: $after, ordering: $ordering) {\n    count\n    edges {\n      node {\n        ...userNameInlineFragment\n        ...userFragment\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment userFragment on User {\n  id\n  firstName\n  lastName\n  photoUrls\n  phone\n  userRole {\n    id\n  }\n  points\n  setupComplete\n}\n\nfragment userNameInlineFragment on User {\n  id\n  firstName\n  lastName\n  photoUrls\n  phone\n  userRole {\n    id\n  }\n  points\n  setupComplete\n}\n"
  }
};
})();

(node as any).hash = "25e42b4e352d63f761ef61b8e7f993ca";

export default node;
